import Skeleton from "./Skeleton";

export default function DashboardSkeleton() {
  return (
    <div className="flex flex-col gap-20 p-3">
      <div className="flex justify-between">
        <div className="flex items-center gap-2">
          <div className="size-14 rounded-full bg-gray-200" />
          <div className="flex flex-col gap-1">
            <Skeleton size="lg" className="w-[344px]" />
            <Skeleton size="lg" className="h-[20px] w-44" />
          </div>
        </div>
        <div>
          <Skeleton size="lg" className="h-[44px] w-[344px]" />
        </div>
      </div>
      <div className="flex flex-col gap-5">
        <Skeleton size="sm" className="w-32" />
        <div className="grid grid-cols-3 gap-8">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="flex h-48 flex-col gap-3 rounded-xl bg-gray-50 p-6"
            >
              <div className="flex items-center gap-2">
                <div className="size-16 rounded-full bg-gray-200" />
                <div className="flex min-w-0 flex-1 flex-col gap-1">
                  <Skeleton size="sm" className="w-32" />
                  <Skeleton size="lg" className="w-full" />
                </div>
              </div>
              <div className="flex justify-end">
                <Skeleton size="lg" className="w-24" />
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="flex gap-8">
        <div className="flex w-full flex-col gap-5">
          <Skeleton size="sm" className="w-32" />
          <div className="grid grid-cols-2 gap-8">
            {[1, 2, 3, 4].map((i) => (
              <div
                key={i}
                className="flex h-48 flex-col gap-3 rounded-xl bg-gray-50 p-6"
              >
                <div className="flex items-center gap-2">
                  <div className="size-16 rounded-full bg-gray-200" />
                  <div className="flex min-w-0 flex-1 flex-col gap-1">
                    <Skeleton size="sm" className="w-32" />
                    <Skeleton size="lg" className="w-full" />
                  </div>
                </div>
                <div className="flex justify-end">
                  <Skeleton size="lg" className="w-24" />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="flex w-full flex-col gap-5">
          <Skeleton size="sm" className="w-32" />
          <div className="flex flex-col gap-5">
            {[1, 2, 3, 4].map((i) => (
              <div
                key={i}
                className="flex items-center justify-between gap-3 rounded-xl bg-gray-50 px-5 py-6"
              >
                <div className="flex items-center gap-3">
                  <div className="size-10 rounded-full bg-gray-200" />
                  <Skeleton size="md" className="w-32" />
                </div>
                <Skeleton size="md" className="size-6" />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-5">
        <Skeleton size="sm" className="w-32" />
        <div className="grid grid-cols-3 gap-8">
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex flex-col gap-2">
              <div className="h-60 w-full rounded-xl bg-gray-50" />
              <div className="flex min-w-0 flex-1 flex-col gap-1">
                <Skeleton size="sm" className="w-32" fixed={false} />
                <Skeleton size="lg" className="w-full" fixed={false} />
                <Skeleton size="md" className="w-32" fixed={false} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
